<nb-card class="project-card-container" (click)="onCardClick()">
  <nb-badge
    *ngIf="project.previewModulesAllowed"
    text="🚧 Test Project"
    status="control"
    position="bottom right"
    nbTooltip="This Project is used for testing Terraform Modules for development"
  >
  </nb-badge>
  <nb-card-header>
    <div class="d-flex justify-content-between align-items-start">
      <div class="d-flex flex-column">
        <h3>{{ project.label }}</h3>
        <div class="mt-1">
          <label class="caption-2 weight-400 d-flex"
            >Last Modified:&nbsp;
            <span
              ><app-smart-table-timeago-tooltip
                [value]="getLastModifiedValue(project)"
              ></app-smart-table-timeago-tooltip></span
          ></label>
        </div>
      </div>

      <div
        [nbTooltip]="
          !project?.gitOpsEnabled
            ? 'GitOps is currently disabled. Click to enable'
            : 'GitOps is enabled.'
        "
      >
        <a target="_blank" (click)="handleGitIconClick($event, project)"
          ><nb-icon
            class="mr-2 mt-1"
            [ngStyle]="{ color: !project?.gitOpsEnabled ? '#8ea6c1' : '' }"
            [icon]="
              project?.gitOpsEnabled
                ? project?.vcs?.toLowerCase()
                : 'gitops-outline'
            "
            pack="fci"
            [status]="project?.gitOpsEnabled ? 'primary' : 'basic'"
          ></nb-icon>
        </a>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="flex flex-column">
      <!-- TODO: Use smart table long string component -->

      <div style="max-height: 4rem; height: 4rem; overflow: auto">
        <p
          class="mb-0"
          [ngStyle]="{
            color: !project?.description?.length
              ? 'var(--landing-page-secondary)'
              : 'var(--paragraph-light-color)'
          }"
          style="display: block"
        >
          {{
            project?.description?.length > 0
              ? project?.description?.substring(0, 100)
              : 'Description Not Provided'
          }}
          <span class="weight-600">
            <div
              [nbTooltip]="project?.description"
              style="display: inline"
              *ngIf="project?.description?.length > 100"
            >
              ...
            </div>
          </span>
        </p>
      </div>
    </div>
  </nb-card-body>
</nb-card>
